'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$13() {
  this.btw = null;
  this.btx = false;
}
export { $c_Lpresto_RegisterPageView$$anon$13 as $c_Lpresto_RegisterPageView$$anon$13 };
$p = $c_Lpresto_RegisterPageView$$anon$13.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$13;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$13() {
}
export { $h_Lpresto_RegisterPageView$$anon$13 as $h_Lpresto_RegisterPageView$$anon$13 };
$h_Lpresto_RegisterPageView$$anon$13.prototype = $p;
$p.P = (function() {
  if ((!this.btx)) {
    this.btw = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_T2($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_None$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Some($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Seq$().aD()));
    this.btx = true;
  }
  return this.btw;
});
var $d_Lpresto_RegisterPageView$$anon$13 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$13, "presto.RegisterPageView$$anon$13", ({
  PV: 1,
  a: 1,
  i: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$13 as $d_Lpresto_RegisterPageView$$anon$13 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$13.js.map
